export const GET_ALL_REPORTS = 'app/ManageReports/GET_ALL_REPORTS';
export const GET_ALL_REPORTS_SUCCESS =
  'app/ManageReports/GET_ALL_REPORTS_SUCCESS';
export const GET_ALL_REPORTS_ERROR = 'app/ManageReports/GET_ALL_REPORTS_ERROR';
